module.exports = __webpack_public_path__ + "prod/1.2.3/img/pay-fail.6ba3feed.svg";